import {
    TranslateOutlined,
    ArrowOutwardOutlined,
    InfoOutlined,
    LogoutOutlined,
    Dashboard,
    PeopleAlt,
    AssignmentTurnedIn,
    AutoGraph,
    SettingsSuggest,
    ArrowBack,
} from "mosaic-react-icons";
import { UserRoles } from "../../enums/userRoles";

export const generateSettingsMenuItems = (role, history, locale, i18n) => {
    const settingsAdminRoles = [
        UserRoles.ADMIN,
        UserRoles.BACKOFFICE,
        UserRoles.PP_SUPPORT,
        UserRoles.SUPPORT,
    ];

    if (![...settingsAdminRoles, UserRoles.OWNER].includes(role)) {
        return null;
    }

    const menu = [
        {
            label: i18n`home`,
            action: () => {
                history.push(`/${locale}/`);
            },
            order: 10,
            section: "home",
            createType: null,
            name: "Home",
            to: "/",
            exact: true,
            icon: ArrowBack,
        },
        {
            label: i18n`projects`,
            action: () => {
                history.push(`/${locale}/settings/projects`, { selectedLink: i18n`projects` });
            },
            order: 2,
            section: "projects",
            createType: "Project", 
            name: "Projects",
            to: "/settings/projects",
            exact: true,
            icon: Dashboard,
        },
        {
            label: i18n`users`,
            action: () => {
                history.push(`/${locale}/settings/users`, { selectedLink: i18n`users` });
            },
            order: 3,
            section: "users",
            createType: "User",
            name: "Users",
            to: "/settings/users",
            exact: true,
            icon: PeopleAlt,
        },
        {
            label: i18n`translation_table`,
            action: () => {
                history.push(`/${locale}/settings_new/translations_table`, { selectedLink: i18n`translation_table` });
            },
            order: 8,
            section: "translations_table",
            createType: "TranslationTable",
            name: "Translations_Table",
            to: "/settings_new/translations_table",
            exact: true,
            icon: Dashboard,
        },
    ];

    if (settingsAdminRoles.includes(role)) {
        menu.push(
            {
                label: i18n`organizations`,
                action: () => {
                    history.push(`/${locale}/settings/organizations`, {
                        selectedLink: i18n`organizations`,
                    });
                },
                order: 1,
                section: "organizations",
                createType: "Organization",
                name: "Organizations",
                to: "/settings/organizations",
                exact: true,
                icon: Dashboard,
            },
            {
                label: i18n`rules`,
                action: () => {
                    history.push(`/${locale}/settings/nc_rules`, { selectedLink: i18n`rules` });
                },
                order: 4,
                section: "nc_rules",
                createType: "NcRule",
                name: "Rules",
                to: "/settings/nc_rules",
                exact: true,
                icon: AssignmentTurnedIn,
            },
            {
                label: i18n`settings_menu_kpis`,
                action: () => {
                    history.push(`/${locale}/settings/kpis`, {
                        selectedLink: i18n`kpis`,
                    });
                },
                order: 5,
                section: "kpis",
                createType: "Kpi",
                name: "Kpis",
                to: "/settings/kpis",
                exact: true,
                icon: AutoGraph,
            },
            {
                label: i18n`custom_reports`,
                action: () => {
                    history.push(`/${locale}/settings/custom_reports`, {
                        selectedLink: i18n`custom_reports`,
                    });
                },
                order: 6,
                section: "custom_reports",
                createType: "CustomReportSettings",
                name: "Custom Reports",
                to: "/settings/custom_reports",
                exact: true,
                icon: SettingsSuggest,
            },
            {
                label: i18n`packages`,
                action: () => {
                    history.push(`/${locale}/settings/packages`, {
                        selectedLink: i18n`packages`,
                    });
                },
                order: 7,
                section: "packages",
                createType: "Package",
                name: "Packages",
                to: "/settings/packages",
                exact: true,
                icon: Dashboard,
            }
        );
    }

    let filteredMenu = menu;
    if (role === UserRoles.OWNER) {
        filteredMenu = menu.filter(item => item.section !== "organizations");
    }

    return filteredMenu.sort((a, b) => a.order - b.order);
};

export const generateSlotPropsSettings  = (role, history, locale, i18n) => {
    const settingsMenuItems = generateSettingsMenuItems(role, history, locale, i18n);
    
    if (!settingsMenuItems) return null;
    
    return settingsMenuItems
        .filter(item => item.section !== "home")
        .map(({ icon, ...item }) => item);
};

export const buildSlotPropsForAsideMenu = (
    history,
    locale,
    userInformation,
    setIsLanguageModalOpen,
    logout,
    i18n,
    selectedLink,
    setIsAboutThisDialogOpen,
    auth,
) => {
    if (!userInformation) {
        return {};
    }

    const { name, email, icon } = userInformation;
    const settingsMenuItems = generateSlotPropsSettings (
        userInformation?.role,
        history,
        locale,
        i18n,
    );
    return {
        slotProps: {
            userMenu: {
                name: name,
                surname: "",
                email: email,
                icon: icon,
                items: [
                    {
                        icon: ArrowOutwardOutlined,
                        label: i18n`my profile`,
                        action: () => {
                            history.push(`/${locale}/my_profile/reset_password`);
                        },
                    },
                    {
                        icon: TranslateOutlined,
                        label: i18n`language`,
                        action: () => setIsLanguageModalOpen(true),
                    },
                    {
                        icon: InfoOutlined,
                        label: i18n`about this app`,
                        action: () => setIsAboutThisDialogOpen(true),
                    },
                    { type: "DIVIDER" },
                    {
                        icon: LogoutOutlined,
                        label: i18n`logout`,
                        action: () => {
                            logout(auth);
                        },
                    },
                ],
            },
            ...(settingsMenuItems && {
                settingsMenu: {
                    items: settingsMenuItems,
                },
            }),
        },
        selectedLink,
    };
};
